import { render } from "./index.vue?vue&type=template&id=27c367ec&scoped=true&bindings={\"messages\":\"props\",\"currentMessage\":\"options\",\"isMessage\":\"options\",\"isQuestion\":\"options\",\"currentMessageName\":\"options\",\"currentMessageText\":\"options\",\"currentQuestionText\":\"options\",\"nextMessage\":\"options\",\"runAnswerAction\":\"options\",\"nextAnswer\":\"options\",\"previousAnswer\":\"options\"}"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=27c367ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27c367ec"

export default script